import {Component, OnInit} from "@angular/core";
import {AthletesControllerService} from "../../../core/api/controllers/athletes-controller.service";
import {ActivatedRoute, Params} from "@angular/router";
import * as moment from "moment";
import {NotificationService} from "../../../core/services/notification.service";
import {AgilityControllerService} from "../../../core/api/controllers/agility-controller.service";
import {_pt} from "../../../core/services/preview-text/helpers/preview-text.function";

@Component({
  selector: "app-agility",
  templateUrl: "./agility-rating.component.html",
  styleUrls: ["agility-rating.component.scss"],
  providers: [AthletesControllerService],
})
export class AgilityRatingComponent implements OnInit {
  athleteId: string;

  athlete: any = null;
  agilityRatings: any = [];

  currentPage = 0;

  newStartDate;
  newEndDate;

  loading = false;

  constructor(
    private route: ActivatedRoute,
    private athleteService: AthletesControllerService,
    private notificationService: NotificationService,
    private agilityController: AgilityControllerService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.athleteId = params["id"];
    });

    this.athleteService.getAthleteById(this.athleteId).subscribe(
      (data) => {
        this.athlete = data;
        this.newEndDate = new Date();
        this.newStartDate = new Date(
          this.newEndDate.getFullYear(),
          this.newEndDate.getMonth() - 6,
          this.newEndDate.getDate(),
        );
        this.getAgilityRatingByIdPagin(
          this.athleteId,
          this.newStartDate.getTime(),
          this.newEndDate.getTime(),
          0,
          5,
        );
      },
      (error) => this.notificationService.error(error),
    );
  }

  getAgilityRatingByIdPagin(
    athleteId: string,
    start,
    end,
    page: number,
    size: number,
  ) {
    this.loading = true;
    return this.agilityController
      .getAgilityRatingByIdPaging(athleteId, start, end, page, size)
      .subscribe(
        (data) => {
          this.agilityRatings = data;
          this.loading = false;
        },
        (error) => {
          this.notificationService.error(error);
          this.loading = false;
        },
      );
  }

  downloadAgilityByName(agilityRating) {
    let name = agilityRating.filename;
    return this.agilityController.downloadAgilityRatingByName(name).subscribe(
      (data) => {
        let blob = new Blob([data.data], {
          type: "application/pdf",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = data.filename;
        document.body.appendChild(link);

        link.click();
        window.URL.revokeObjectURL(link.href);
      },
      (error) => this.notificationService.error(error),
    );
  }

  viewAgilityRatingByName(agilityRating) {
    let name = agilityRating.filename;
    return this.agilityController.downloadAgilityRatingByName(name).subscribe(
      (data) => {
        let blob = new Blob([data.data], {
          type: "application/pdf",
        });

        window.open(URL.createObjectURL(blob), "_blank");
      },
      (error) => this.notificationService.error(error),
    );
  }

  getResultData() {
    this.loading = true;
    this.agilityController
      .getAgilityRatingByIdPaging(
        this.athleteId,
        this.newStartDate.getTime(),
        this.newEndDate.getTime(),
        this.currentPage,
        3,
      )
      .subscribe(
        (data) => {
          this.loading = false;
          this.agilityRatings = data;
        },
        (error) => {
          this.notificationService.error(error);
          this.loading = false;
        },
      );
  }

  changeDate(type: string, event: any) {
    this.newStartDate = moment(event.value.begin).toDate();
    this.newEndDate = moment(event.value.end).toDate();
  }

  isValidDate(newStartDate, newEndDate) {
    return moment(newStartDate).isValid() && moment(newEndDate).isValid();
  }

  resetValues() {
    this.newStartDate = "";
    this.newEndDate = "";
  }

    protected readonly _pt = _pt;
}
